import React, { useEffect, useMemo, useRef, useState } from "react";
import { VOMNavbar } from ".";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchVOMRequestDetails,
  fetchVOMRequests,
  fetchVOMRequestsForBorrower,
} from "../../store/reducers/dashboardSlice/api";
import SignatureField, { CustomAlert } from "./SignatureField";
import PopupWrapper from "../../components/PopupWrapper";
import ReactSignatureCanvas from "react-signature-canvas";
import axios from "axios";
import urls from "../../Utils/urls";
import { oracleConfig } from "../../Utils/constant";
import { LoadingButton, SpinnerBlock } from "../../Utils/CustomComponent";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import moment from "moment";

const VOMDetails = () => {
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [signature, setSignature] = useState(null);
  const [loading, setLoading] = useState(false);
  const borrowerEmail = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  const isAuthenticated = useSelector(
    (state) => state.RS_Authentication.isAuthenticated,
  );
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );
  const vomRequests = useSelector((state) => state.dashboard.vomRequests.data);
  const borrowerVOMRequests = useSelector(
    (state) => state.dashboard.borrowerVOMRequests.data,
  );
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const location = useLocation();
  // const isExternalBorrower = location?.pathname?.includes(
  //   "/vom-details/external/"
  // );

  const accounts = useMemo(
    () => accountOptions.map((item) => item.value),
    [accountOptions],
  );
  const { requestId, email } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const vomDetails = email
    ? (vomRequests?.filter((el) => el.request_id == requestId)?.[0] ?? null)
    : selectedRole && selectedRole === "B"
      ? borrowerVOMRequests?.filter((el) => el.request_id == requestId)?.[0]
      : null;
  // selectedRole && selectedRole === "B" && !isExternalBorrower
  //   ? borrowerVOMRequests?.filter((el) => el.request_id == requestId)?.[0] ??
  //     null
  //   : vomRequests?.filter((el) => el.request_id == requestId)?.[0] ?? null;

  useEffect(() => {
    if (email) {
      dispatch(fetchVOMRequests({ email }));
    } else {
      if (selectedRole && selectedRole === "B" && accounts?.length) {
        dispatch(
          fetchVOMRequestsForBorrower({
            payload: { loanrecid: accounts },
          }),
        );
      }
    }
  }, [dispatch, selectedRole, accounts, email]);

  async function onSubmit(base64Signature) {
    const id = toast.loading("Submitting...");
    setLoading(true);
    try {
      const payload = {
        borrower_signature: base64Signature,
        loanrecid: vomDetails?.loanrecid,
        email: email ? email : borrowerEmail,
        request_id: vomDetails?.request_id,
        borrower_sign_available: "Y",
      };

      await axios.post(urls.VOM.postBorrowerSignature, payload, oracleConfig);
      toast.update(id, {
        render: "Submitted Successfully!",
        type: "success",
        isLoading: false,
        ...commonToast,
      });

      if (email) {
        navigate("/thankyou", {
          state: {
            text: "Your signature has been successfully submitted.",
            btnText: "Return to Home Page",
            showBtn: true,
            navLink: `/vom/borrower/${email}`,
          },
        });
      } else {
        navigate("/voms/borrower");
      }
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "Some error occured. Please try again.",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setLoading(false);
      toast.dismiss(id);
    }
  }

  return (
    // <div className="container my-5" style={{ background: "#eeeeee" }}>
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <div
        className=" rounded py-5"
        style={{
          background: "#eeeeee",
          minHeight: "100vh",
        }}
      >
        {vomDetails !== null ? (
          <div className="container">
            {/* Back */}
            <div className="my-3">
              <button
                onClick={() => navigate(-1)}
                className="btn btn-link px-0"
              >
                ← Back
              </button>
            </div>

            {/* Main Card */}
            <div className="card border-0 shadow-lg rounded-4">
              <div className="card-body p-4 p-md-5">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-start flex-wrap mb-4">
                  <div>
                    <h3 className="fw-bold mb-1">Verification of Mortgage</h3>

                    <p className="text-muted mb-0">
                      Requested on:{" "}
                      <strong>
                        {vomDetails?.request_date
                          ? moment(vomDetails?.request_date)?.format(
                              "MM-DD-YYYY",
                            )
                          : "-"}
                      </strong>
                    </p>
                  </div>

                  <span
                    className={`badge px-5 py-3 ${
                      vomDetails?.status === "PENDING"
                        ? "bg-info"
                        : "bg-success"
                    }`}
                  >
                    {vomDetails?.status}
                  </span>
                </div>

                <hr />

                {/* Sent To / Sent From */}
                <div className="row g-4 my-5 text-start">
                  <div className="col-md-6">
                    <h5 className="fw-bold">Sent To (Lender / Servicer)</h5>
                    <p className="mb-1 text-muted">{vomDetails?.send_to}</p>
                    {/* <p className="mb-1 text-muted">{vomDetails?.to_address}</p> */}
                    <p className="mb-1 text-muted">
                      28348 Roadside Dr. 1st Floor
                    </p>
                    <p className="mb-1 text-muted">Agoura Hills - CA 91301</p>
                  </div>

                  <div className="col-md-6">
                    <h5 className="fw-bold">Sent From</h5>
                    <p className="mb-1 fw-semibold text-muted">
                      {vomDetails?.send_from}
                    </p>
                    <p className="mb-1 text-muted">
                      {vomDetails?.from_address
                        ?.split(",")
                        ?.filter((el) => el !== "")
                        .join(",")}
                    </p>
                    <p className="mb-1 text-muted">{vomDetails?.email}</p>
                    <p className="mb-0 text-muted">
                      {vomDetails?.lender_number}
                    </p>
                  </div>
                </div>

                <hr className="my-4" />

                {/* Property & Loan Info */}
                <div className="row g-4 text-start my-5">
                  <div className="col-md-6">
                    <h6 className=" mb-3 fs-5 fw-bold">Loan Information</h6>
                    <p className="mb-1 text-muted">
                      <span>Account Name:</span>{" "}
                      {vomDetails?.account_in_the_name_of}
                    </p>
                    <p className="mb-0 text-muted">
                      <span>Loan Number:</span>{" "}
                      {vomDetails?.loan_number ?? vomDetails?.account_number}
                    </p>
                    <p className="mb-1 text-muted">
                      {vomDetails?.propa_street}
                    </p>
                    <p className="mb-0 text-muted">
                      {vomDetails?.propa_city &&
                        vomDetails?.propa_state &&
                        vomDetails?.propa_zipcode &&
                        `${vomDetails?.propa_city}, ${vomDetails?.propa_state} 
                      ${vomDetails?.propa_zipcode}`}
                    </p>
                  </div>

                  <div className="col-md-6">
                    <h5 className="fw-bold mb-2">Applicant</h5>
                    <p className="mb-0 text-muted">
                      {vomDetails?.applicant_name_and_address ??
                        vomDetails?.applicant_name}
                    </p>
                  </div>
                </div>

                {/* <hr className="mt-4" /> */}
                {isAuthenticated &&
                selectedRole === "B" &&
                !email &&
                vomDetails?.borrower_sign_yn === "N" &&
                vomDetails?.status === "PENDING" ? (
                  <VOMFeeAlert />
                ) : email &&
                  vomDetails?.status === "PENDING" &&
                  vomDetails?.borrower_yn === "Y" ? (
                  <VOMFeeAlert />
                ) : null}

                {/* Applicant */}

                {/* <hr className="my-4" /> */}

                {/* Signature Section */}
                {isAuthenticated &&
                selectedRole === "B" &&
                !email &&
                vomDetails?.borrower_sign_yn === "N" &&
                vomDetails?.status === "PENDING" ? (
                  <div className="text-center mt-4">
                    {vomDetails?.borrower_sign_yn === "Y" ? (
                      <div className="alert alert-success rounded-3">
                        Verification already signed.
                      </div>
                    ) : (
                      <>
                        <p className="text-muted mb-5">
                          This verification requires your signature to proceed.
                        </p>

                        <LoadingButton
                          loading={loading}
                          disabled={loading}
                          type="button"
                          className="btn btn-lg px-5 text-white my-3 btn-modern-outline"
                          onClick={() => setShowSignaturePad(true)}
                          title={"Review & Sign Verification"}
                        />
                      </>
                    )}
                  </div>
                ) : (
                  email &&
                  vomDetails?.borrower_yn === "Y" && (
                    <div className="text-center">
                      {vomDetails?.borrower_signature_yn === "Y" ? (
                        <div className="alert alert-success rounded-3">
                          Verification already signed.
                        </div>
                      ) : (
                        vomDetails?.status === "PENDING" &&
                        vomDetails?.borrower_yn === "Y" && (
                          <>
                            <p className="text-muted mb-5">
                              This verification requires your signature to
                              proceed.
                            </p>

                            <LoadingButton
                              loading={loading}
                              disabled={loading}
                              type="button"
                              className="btn btn-lg px-5 text-white my-3 btn-modern-outline"
                              onClick={() => setShowSignaturePad(true)}
                              title={"Review & Sign Verification"}
                            />
                          </>
                        )
                      )}
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <SpinnerBlock height={"10vh"} />
          </div>
        )}
      </div>
      <SignatureBox
        showSignaturePad={showSignaturePad}
        setShowSignaturePad={setShowSignaturePad}
        setSignature={setSignature}
        onSubmit={onSubmit}
        loading={loading}
      />
    </div>
  );
};

export default VOMDetails;

export const VOMDetailsForExternal = () => {
  return (
    <div>
      <VOMNavbar />
      <div style={{ paddingTop: "3.5rem" }}>
        <VOMDetails />
      </div>
    </div>
  );
};

const SignatureBox = ({
  showSignaturePad,
  setShowSignaturePad,
  setSignature,
  onSubmit,
  loading,
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const signatureRef = useRef(null);

  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });
  };

  const saveSignature = async (e) => {
    e.preventDefault();

    function validateStrokes() {
      const strokeData = signatureRef.current.toData();
      const minStrokeLength = 50; // Minimum stroke length (in pixels)

      let totalLength = 0;

      strokeData.forEach((stroke) => {
        let strokeLength = 0;
        for (let i = 1; i < stroke.length; i++) {
          const dx = stroke[i].x - stroke[i - 1].x;
          const dy = stroke[i].y - stroke[i - 1].y;
          strokeLength += Math.sqrt(dx * dx + dy * dy);
        }
        totalLength += strokeLength;
      });

      if (totalLength < minStrokeLength) {
        return false;
      } else {
        return true;
      }
    }

    if (signatureRef.current) {
      if (signatureRef.current.isEmpty()) {
        setShowAlert(true);
        return;
      }

      const isValid = validateStrokes();
      if (isValid) {
        const response = await fetch(
          signatureRef.current.getTrimmedCanvas().toDataURL("image/png"),
        );
        const blob = await response.blob();
        const base64Signature = await convertBlobToBase64(blob);

        setSignature(base64Signature);
        await onSubmit(base64Signature);
        setShowSignaturePad(false);
      } else {
        setShowAlert(true);
      }
    }
  };

  const clearSignature = (e) => {
    e.preventDefault();
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };
  return (
    <div>
      {showSignaturePad && (
        <PopupWrapper
          title={"Sign Here"}
          Component={
            <div
              style={{
                backgroundColor: "white",
                // padding: "20px",
                // position: "relative",
              }}
            >
              <div className="border border-1">
                <ReactSignatureCanvas
                  ref={signatureRef}
                  penColor="black"
                  canvasProps={{
                    width: "720px",
                    height: "300px",
                    className: "sigCanvas",
                  }}
                />
              </div>
              <div className="d-flex justify-content-end gap-5 mt-5 mb-3">
                <button
                  className="btn btn-secondary border btn-modern-outline"
                  onClick={clearSignature}
                >
                  Clear
                </button>
                <LoadingButton
                  loading={loading}
                  disabled={loading}
                  type="button"
                  className="btn btn-primary text-white btn-modern-outline"
                  onClick={saveSignature}
                  title={"Submit"}
                />
              </div>
            </div>
          }
          toShow={showSignaturePad}
          extraClass={"min-width-50vw"}
          closeEventHandler={() => {
            setShowSignaturePad(false);
          }}
          titleClassName={"w-100"}
          bodyStyle={
            {
              // maxHeight: "50vh",
            }
          }
        />
      )}
      <CustomAlert showAlert={showAlert} setShowAlert={setShowAlert} />
    </div>
  );
};

const VOMFeeAlert = () => {
  return (
    <div className="vom-fee-alert">
      <div className="vom-fee-icon">!</div>
      <div className="vom-fee-content">
        <p className="vom-fee-title">
          After you authorize this VOM request, a <strong>$30 VOM fee</strong>{" "}
          will apply.
        </p>
        <p className="vom-fee-text">
          If the requesting party does not pay the fee directly, the $30 charge
          will be added to your loan account as a{" "}
          <strong>deferred charge</strong>.
        </p>
      </div>
    </div>
  );
};
